import { render, staticRenderFns } from "./PlatMenu.vue?vue&type=template&id=5a77c39b"
import script from "./PlatMenu.vue?vue&type=script&lang=js"
export * from "./PlatMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports